import * as types from '../actions/action-types';
import {createSpaceOrRegex} from '../../utils/search-utils';
import _ from 'lodash';

const defaults = {
  loading: true,
  filterText: '',
  list: []
};

/**
 * Set initial data and loading false
 *
 * @param store
 * @param data
 */
function setData(store, data) {
  return filterPlayers({
    ...store,
    loading: false,
    raw: data
  });
}

function filterPlayers(store, filterText) {
  const regex = createSpaceOrRegex(filterText);

  const list = _.filter(store.raw, p => {
    const text = p.name + ' ' + p.team.name;
    return filterText ? text.match(regex) : true;
  });

  return {
    ...store,
    filterText,
    list
  }
}

export default (store = defaults, action) => {
  switch (action.type) {
    case types.SET_PLAYER_FILTER:
      return filterPlayers(store, action.filterText);
    case types.RECEIVED_PLAYER_LIST:
      return setData(store, action.data);
    default:
      return store;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/players-reducer.js